export default __webpack_public_path__ + "static/media/gold.b44f942c.png";